import { styled } from '../../styled-components';

export const EditableTex = styled.div.attrs({
  className: 'EditableTextContainer',
})`
  font-size: ${p => p.theme.fontSizeLargeX};
  margin-right: ${p => p.theme.spaceSmall};
`;
